import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { CampaignRequestsRoutes } from '../../../routes';

export const CampaignRequestsLayout = () => <SwitchRoute routes={CampaignRequestsRoutes} />;
